import { keys, values } from "lodash";
import { handleUpdateElementsLabel, handleUpdateNetsLabel } from "../document-actions";
/**
 * Applies designator changes to components and nets
 * @param action The designators action to apply
 * @param dependencies The dependencies needed to apply the action
 * @returns A promise that resolves to the result of applying the action
 */
export function applyDesignatorsAction(action, document, actionContext) {
    const touchedElementUids = [];
    const elements = document.elements;
    const updatedElements = [];
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    action.componentDesignatorsToEdit.forEach((componentDesignator) => {
        const matchesDesignator = (element) => element.label?.toLowerCase().trim() ===
            componentDesignator.existingComponentDesignator.toLowerCase().trim();
        const notAlreadyChosen = (element) => !updatedElements.find((el) => el.uid === element.uid);
        const element = values(elements || {}).find((element) => matchesDesignator(element) && notAlreadyChosen(element));
        if (element) {
            const newDesignator = componentDesignator.newComponentDesignator;
            const newElement = { ...element, label: newDesignator };
            updatedElements.push(newElement);
            touchedElementUids.push(element.uid);
        }
    });
    if (updatedElements.length > 0) {
        handleUpdateElementsLabel(document, updatedElements, actionContext.logger);
    }
    const nets = document.nets;
    const netLabelMap = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    action.netDesignatorsToEdit.forEach((netDesignator) => {
        const net = values(nets).find((net) => net.label?.toLowerCase().trim() === netDesignator.existingNetDesignator.toLowerCase().trim());
        if (net) {
            netLabelMap[net.uid] = netDesignator.newNetDesignator;
        }
    });
    if (keys(netLabelMap).length > 0) {
        handleUpdateNetsLabel(document, netLabelMap);
    }
    return {
        componentDesignatorsUpdated: Object.fromEntries(action.componentDesignatorsToEdit.map((d) => [d.existingComponentDesignator, d.newComponentDesignator])),
        netDesignatorsUpdated: { ...netLabelMap },
        touchedElementUids,
    };
}
//# sourceMappingURL=applyDesignatorsAction.js.map